import Transform from "@ember-data/serializer/transform";
import TimedTransaction from "parog-web/models/timed-transaction";

interface SerializedTimedTransaction {
  name: string;
  start_date: Date;
  end_date?: Date;
  success?: boolean;
  error?: {
    name: string;
    message: string;
  };
}
export default class TimedTransactionTransform extends Transform {
  override deserialize(
    serialized: SerializedTimedTransaction[] | null
  ): TimedTransaction[] | null {
    return (
      serialized?.map(
        item =>
          new TimedTransaction(
            item["name"],
            item["start_date"],
            item["end_date"],
            item["success"],
            item["error"]
          )
      ) || []
    );
  }

  override serialize(
    deserialized: TimedTransaction[] | null
  ): SerializedTimedTransaction[] | null {
    return (
      deserialized?.map(item => {
        return {
          name: item.name,
          start_date: item.startDate,
          end_date: item.endDate,
          success: item.success,
          error: item.error
        };
      }) || []
    );
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    "timed-transactions": TimedTransactionTransform;
  }
}
